
import { ANSWER_GIVEN, ANSWER_PROCESSED, BET_PLACED, USER_ANSWERS_RECEIVED, ANSWER_NOTIFIED} from './actions'
import { STARTED_MATCH } from '../matches'
import {BET_STARTED} from '../questionGame/actions'

/*
is_notified = 0 <-- La risposta non è ancora stata mostrata
is_notified = 1 <-- La risposta è in mostra ora
is_notified = 2 <-- La risposta è stata già mostrata


*/

export const  userAnswer = (state = {}, action) => {
    switch (action.type) {

        case ANSWER_GIVEN:
            return {
            ...state,
                [action.game_id+" "+action.question_id]: {
                    ...state[action.game_id+" "+action.question_id],
                    answerMs: action.answerMs,
                    answer:action.answer,
                    old_balance: action.old_balance
                }
             }
        
        case ANSWER_PROCESSED:
        return {
            ...state,
                [action.user_answer.game_id+" "+action.user_answer.question_id]: {
                    ...state[action.user_answer.game_id+" "+action.user_answer.question_id],
                    gain: action.user_answer.gain,
                    old_balance:action.user_answer.old_balance,
                    new_balance:action.user_answer.new_balance,
                    quote:action.user_answer.quote,
                    answer_id:action.user_answer.answer_id,
                    pity_bonus:action.user_answer.pity_bonus,
                    is_notified:1
                }
             }

        case BET_STARTED:
             return {
                 ...state,
                     [action.game_id+" "+action.question.id]: {
                         ...state[action.game_id+" "+action.question.id],
                        question_id : action.question.id, 
                        game_id: action.game_id
                    }
                  }
        
        case BET_PLACED:
        return {
            ...state,
                [action.game_id+" "+action.question_id]: {
                    ...state[action.game_id+" "+action.question_id],
                    bet:action.bet,
                    is_notified: 0,
                    old_balance: action.old_balance
                }
             }

        case STARTED_MATCH:
            var newState = {...state}
            var newStateKeys = Object.keys(newState)
            for (var i = 0; i < newStateKeys.length; i++){
                if (newStateKeys[i].startsWith(action.match.id)){
                    delete newState[newStateKeys[i]]
                }
            }
            return newState
        
        case USER_ANSWERS_RECEIVED:
            var newState = {...state}
            var answers = action.userAnswers
            for (var j = 0; j< answers.length; j++){
                var ans = answers[j]
                newState[ans.game_id+" "+ans.question_id] = {
                    ...ans
                }
            }
            return newState;

        case ANSWER_NOTIFIED:
            return {
                ...state,
                    [action.user_answer.game_id+" "+action.user_answer.question.id]: {
                        ...state[action.user_answer.game_id+" "+action.user_answer.question.id],
                        is_notified:2
                    }
                }

        default:
            return state
    }
}

export const betPlaced = (game_id, question_id, user_id, bet) => {
    return {type: BET_PLACED, question_id, game_id, user_id, bet}
}


// WEBPACK FOOTER //
// ./src/reducers/userAnswer/index.js